'use client';

import { ConvexReactClient } from 'convex/react';
import { ReactNode, useEffect } from 'react';
import { getEnvConfig } from '@/lib/env';
import { ConvexProvider } from 'convex/react';

const { convexUrl } = getEnvConfig();
const convex = new ConvexReactClient(convexUrl);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Add a global error handler for unhandled promise rejections
    // This will catch Convex connection errors
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the default browser behavior (console error)
      event.preventDefault();
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return <ConvexProvider client={convex}>{children}</ConvexProvider>;
}
